import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../lib/api';
import { Card, CardContent } from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Button from '../../components/ui/Button';
import { Settings, Plus } from 'lucide-react';

export default function AdminCommissionRulesPage() {
  const { data: rules } = useQuery({ queryKey: ['commissionRules'], queryFn: () => api.get('/commissions/rules').then(r => r.data) });
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between"><div><h1 className="text-2xl font-bold text-white">Commission Rules</h1><p className="text-sm text-slate-400">Configure direct and level commission rules</p></div><Button size="sm"><Plus className="w-4 h-4 mr-1" />Add Rule</Button></div>
      <Card><CardContent className="p-0"><div className="overflow-x-auto"><table className="w-full">
        <thead><tr className="border-b border-white/[0.06] bg-white/[0.02]">
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Name</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Type</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Percentage</th>
          <th className="text-left px-4 py-3 text-xs font-semibold text-slate-400 uppercase">Status</th>
        </tr></thead>
        <tbody className="divide-y divide-white/[0.04]">{rules?.map((r: any) => (
          <tr key={r.id} className="hover:bg-white/[0.02]">
            <td className="px-4 py-3 text-sm font-medium text-white">{r.name}</td>
            <td className="px-4 py-3"><Badge status={r.type} /></td>
            <td className="px-4 py-3 text-sm font-medium text-white">{r.percentage}%</td>
            <td className="px-4 py-3"><Badge status={r.isActive ? 'ACTIVE' : 'INACTIVE'} /></td>
          </tr>
        ))}</tbody>
      </table></div></CardContent></Card>
    </div>
  );
}
